import { render, staticRenderFns } from "./CategoryBooks.vue?vue&type=template&id=4725be21&"
import script from "./CategoryBooks.vue?vue&type=script&lang=js&"
export * from "./CategoryBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports